import { createFileRoute } from '@tanstack/react-router';
import { fetchMySlcpAssessments } from '@/api/slcp';
import {
  buildMySlcpAssessmentsQs,
  mySlcpAssessmentsKeys,
} from '@/app/(client)/slcp/-hooks/useMySlcpAssessments';
import { SlcpMyAssessmentsTable } from '@/components/shared/SlcpMyAssessmentsTable';
import { queryClient } from '@/lib/utils/queryClient';
import { useSessionStore } from '@/store/sessionStore';

export const Route = createFileRoute(
  '/(client)/slcp/(pages)/(list)/my-own/active/',
)({
  loader: async () => {
    try {
      await queryClient.ensureQueryData({
        queryKey: mySlcpAssessmentsKeys.list(false),
        queryFn: () =>
          fetchMySlcpAssessments(
            buildMySlcpAssessmentsQs({ isArchived: false }),
          ),
      });
    } catch {
      /* noop — backend 4xx when facility id missing/invalid */
    }
  },
  component: ActiveMySlcpPage,
});

function ActiveMySlcpPage() {
  const companyId = useSessionStore(s => s.user?.companyId ?? '');
  const ownCompanyName = useSessionStore(s => s.user?.company?.name ?? '');

  return (
    <SlcpMyAssessmentsTable
      companyId={companyId}
      ownCompanyName={ownCompanyName}
      isArchived={false}
    />
  );
}
